import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ui-m000-c040-loading-spinner',
    standalone: true,
    templateUrl: './m000-c040-loading-spinner.component.html',
    styleUrl: './m000-c040-loading-spinner.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
})
export class M000C040LoadingSpinnerComponent {}
